export default __webpack_public_path__ + "static/media/setting-search.db4c6e9f.svg";